

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import IconButtonWithTooltip from "components/buttons/IconButtonWithTooltip";
import { Line } from "react-chartjs-2";
import Skeleton from "react-loading-skeleton";
import { Button, CardTitle, Col } from "reactstrap";
import { chartExample2 } from 'variables/charts';
import { faExpand, faCompress} from '@fortawesome/free-solid-svg-icons';

export const DiagramHeader = ({ headerText, title, isLoading, icon }) => {
    return(
        <Col className="text-left" xl="4" sm="6">
            <h5 className="card-category" style={{cursor:"default"}}>
                {headerText}
            </h5>
            <CardTitle tag="h3" style={{cursor:"default"}}>
                {isLoading ? 
                    <Skeleton count={1} height={20}/> 
                :
                    <>
                        <i className={icon} /> 
                        {title}
                    </>
                }
            </CardTitle>
        </Col>
    )
}

export const DiagramButton = ({id, category, setCategory, buttonCategory, label, icon, tooltipTranslationid}) => {
    return(
    <Button
        tag="label"
        className={classNames("btn-simple", { active: category === buttonCategory, })}
        color="info"
        id={id}
        size="sm"
        onClick={() => setCategory(buttonCategory)}
    >
        <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
            {label}
        </span>
        <span className="d-block d-sm-none">
            { tooltipTranslationid ?
                <IconButtonWithTooltip size="lg" translationId={tooltipTranslationid} icon={icon} color={category === buttonCategory ? 'white' : 'black'}/>
                :
                <i className={icon} />
            }
        </span>
    </Button>)
}

export const DiagramBody = ({chartData, isLoading}) => {
    return(
        <div className="chart-area">
            {isLoading ? 
                <Skeleton count={1} height={200}/> 
            : 
            <>
                <Line data={chartData} options={chartExample2.options}/>
            </>}
        </div>
    )
}

export const MaximizeButton = ({ isMaximized, toggleMaximize }) => {
    return (
        <FontAwesomeIcon
            icon={isMaximized ? faCompress : faExpand}
            className={`maximize-icon${isMaximized ? ' minimized' : ''}`}
            onClick={toggleMaximize}
        />
    )
}